// eslint-disable no-use-before-define
// eslint-disable react/prop-types
import React, { useEffect } from "react";
import { useLocation, matchPath } from "react-router";
import { Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Chip,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  Button,
  makeStyles,
} from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/ReceiptOutlined";
import {
  Calendar as CalendarIcon,
  Folder as FolderIcon,
  Edit as EditIcon,
  Mail as MailIcon,
  MessageCircle as MessageCircleIcon,
  PieChart as PieChartIcon,
  Users,
  List as ListAltIcon,
} from "react-feather";
import Logo from "src/components/Logo";
import NavItem from "./NavItem";
import { Apartment, Group, LibraryBooks, ListAlt } from "@material-ui/icons";

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }) {
  const key = item.title + depth;
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });
    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
        enabled={item.enabled}
        style={{
          display:
            item.currentrole === "admin"
              ? "block"
              : item.owner === item.currentrole
              ? // item.currentrole !== 'user-inhouse' ?
                "block"
              : // : "none"
              item.owner === "all"
              ? "block"
              : "none",
        }}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
        enabled={item.enabled}
      />
    );
  }

  return acc;
}

const imageLocation = process.env.REACT_APP_IMAGE;

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
}));

function NavBar({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useSelector((state) => state.account);

  const navConfig = [
    /** user dashboard **/
    {
      subheader: "",
      owner: "user",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/app/reports/dashboard",
          enabled: true,
        },
      ],
    },

    // user
    {
      subheader: "Reports",
      owner: "user",
      items: [
        {
          title: "Property Holdings",
          icon: ListAltIcon,
          href: "/app/reports/dashboard/property/holdings",
          enabled: true,
        },
        {
          title: "Payment History",
          icon: ListAltIcon,
          href: "/app/reports/dashboard/property/history",
          enabled: true,
        },
        {
          title: "Statement of Account",

          icon: ListAltIcon,
          href: "/app/reports/dashboard/property/soa",
          enabled: true,
        },
      ],
    },

    /** admin dashboard **/
    {
      subheader: "",
      owner: "admin",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/administrator/dashboard",
          enabled: true,
        },
      ],
    },

    // admin
    {
      subheader: "Report",
      owner: "admin",
      items: [
        {
          title: "Payments",
          icon: ListAlt,
          href: "/administrator/reports/payments",
          enabled: true,
        },
        {
          title: "Property Enrollment",
          icon: ListAlt,
          href: "/administrator/reports/property-enrollment",
          enabled: true,
        },
      ],
    },

    // admin
    {
      subheader: "Users",
      owner: "admin",
      items: [
        {
          title: "List",
          icon: Users,
          href: "/administrator/users",
          enabled: true,
        },
      ],
    },

    // report analyst assessor
    {
      subheader: "",
      owner: "report analyst assessor",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/report-analyst-assessor/dashboard",
          enabled: true,
        },
      ],
    },

    // report analyst treasurer
    {
      subheader: "",
      owner: "report analyst treasurer",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/report-analyst-treasurer/dashboard",
          enabled: true,
        },
      ],
    },

    {
      subheader: "",
      owner: "report analyst treasurer",
      items: [
        {
          title: "Delinquent",
          icon: Group,
          href: "/report-analyst-treasurer/delinquent",
          enabled: true,
        },

        {
          title: "Business",
          icon: Apartment,
          href: "/report-analyst-treasurer/business",
          enabled: true,
        },

        {
          title: "General Collection",
          icon: LibraryBooks,
          href: "/report-analyst-treasurer/general-collection",
          enabled: true,
        },
      ],
    },

    // provencial report analyst assessor
    {
      subheader: "",
      owner: "provencial report analyst assessor",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/provencial-report-analyst-assessor/dashboard",
          enabled: true,
        },

        {
          title: "RPUs Municipality",
          icon: PieChartIcon,
          href: "/provencial-report-analyst-assessor/rpus-municipality",
          enabled: true,
        },
      ],
    },

    // provencial report analyst treasurer
    {
      subheader: "",
      owner: "provencial report analyst treasurer",
      items: [
        {
          title: "Dashboard",
          icon: PieChartIcon,
          href: "/provencial-report-analyst-treasurer/dashboard",
          enabled: true,
        },
      ],
    },

    {
      subheader: "",
      owner: "provencial report analyst treasurer",
      items: [
        {
          title: "Delinquent",
          icon: Group,
          href: "/provencial-report-analyst-treasurer/delinquent",
          enabled: true,
        },
      ],
    },

    {
      subheader: "",
      owner: "provencial report analyst treasurer",
      items: [
        {
          title: "Business",
          icon: Apartment,
          href: "/provencial-report-analyst-treasurer/business",
          enabled: true,
        },
      ],
    },

    {
      subheader: "",
      owner: "provencial report analyst treasurer",
      items: [
        {
          title: "General Collection",
          icon: LibraryBooks,
          href: "/provencial-report-analyst-treasurer/general-collection",
          enabled: true,
        },
      ],
    },

    // Documents
    {
      subheader: "Documents",
      owner: user.roles[0].name,
      items: [
        {
          title: "FAAS",
          icon: EditIcon,
          href: "/app/management/faas",
          enabled: false,
        },
        {
          title: "Tax Declaration",
          icon: ReceiptIcon,
          href: "/app/management/products",
          enabled: false,
        },
        {
          title: "Certificates",
          icon: FolderIcon,
          href: "/app/management/certificates",
          enabled: false,
          items: [
            {
              title: "Witholding Tax Cert",
              href: "/app/management/taxcert",
              enabled: false,
            },
            {
              title: "Land Holdings",
              href: "/app/management/landholdings/1",
              enabled: false,
            },
          ],
        },
      ],
    },

    // Applications
    {
      subheader: "Applications",
      items: [
        {
          title: "Mail",
          href: "/app/mail",
          icon: MailIcon,
          enabled: false,
          info: () => <Chip color="secondary" size="small" label="Updated" />,
        },
        {
          title: "Chat",
          href: "/app/chat",
          icon: MessageCircleIcon,
          enabled: false,
          info: () => <Chip color="secondary" size="small" label="Updated" />,
        },
        {
          title: "Calendar",
          href: "/app/calendar",
          icon: CalendarIcon,
          enabled: false,
        },
      ],
    },
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <RouterLink to="/">
              <Logo />
            </RouterLink>
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="/app/account">
              <Avatar
                alt="User"
                className={classes.avatar}
                src={`${imageLocation}avatar/${user.avatar}`}
              />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to="/app/account"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {`${user.firstname} ${user.lastname}`}
            </Link>
            <Typography variant="body2" color="textSecondary">
              {user.bio}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
          {navConfig
            .filter((x) => x.owner === user.roles[0].name.trim())
            .map((config, index) => (
              <List
                key={index}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {config.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  items: config.items,
                  pathname: location.pathname,
                })}
              </List>
            ))}
        </Box>
        <Divider />
        <Box p={1}>
          <Box p={2} borderRadius="borderRadius" bgcolor="background.dark">
            <Typography variant="h6" color="textSecondary" align="center">
              To register your property? Click{" "}
              {/* <a
                href="mailto:register.rpu.marilao@gmail.com?subject=Request for Real Property Registration&body=Hi,
                      I would like to request the attached file(s) for the registration on eRPT Online Payment App."
              >
                register.rpu.marilao@gmail.com
              </a> */}
            </Typography>

            <Box mt={1}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                component={RouterLink}
                to="/app/property/register"
                fullWidth
                disabled={user?.roles?.[0]?.name?.trim() !== "user"}
              >
                {" "}
                Register{" "}
              </Button>
            </Box>
            {/* <Typography variant="h6" color="textWarning">
              Please use your registered email account
            </Typography> */}
            {/* <Link
              variant="subtitle1"
              color="secondary"
              component={RouterLink}
              to="/docs"
            >
              Check our docs
            </Link> */}
          </Box>
        </Box>
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
